import React from "react"
import get from 'lodash/get'
import set from 'lodash/set'
import clone from 'lodash/clone'
import Searchbar from '../searchbar/searchbar-licensing'
import LicensingTable from '../table/table-licensing'
import { addButton } from '../helper/button'
import { ConfirmSaveForm, AddLicenseForm } from '../form'
import { license_type } from '../../project-information/constants/index'

export default class LicensingTab extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'projectByID')
    && JSON.stringify(get(nextProps, 'projectByID')) !== JSON.stringify(prevState.projectByID)
    ) {
      const projectByID = get(nextProps, 'projectByID')
      set(tempState, 'projectByID', projectByID)
      set(tempState, 'licenses', projectByID.licenses)
    }
    if (get(nextProps, 'editLicense') !== get(prevState, 'editLicense')) {
      set(tempState, 'editLicense', get(nextProps, 'editLicense'))
    }
    return tempState
  }

  state={
    editLicense: false,
    showAddLicense: false,
    search_license: '',
    licenses: [],
    license_name: '',
    license_description: '',
    license_cost: 0,
    license_price: 0,
    license_sub_project_code: '',
    license_type: '',
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
    && JSON.stringify(this.state) === JSON.stringify(nextState)) return false
    return true
  }

  addLicense = () => {
    const oldLicenses = this.state.licenses
    const license = {}
    let licenses = []
    license.name = this.state.license_name
    license.description = this.state.license_description
    license.type = this.state.license_type
    license.sub_project_code = this.state.license_sub_project_code
    license.cost = this.state.license_cost
    license.price = this.state.license_price
    licenses = [...oldLicenses, license]
    this.setState({
      licenses,
      showAddLicense: !this.state.showAddLicense,
    })
  }

  confirmEditLicense= () => {
    const editProjectInformation = get(this.props, 'editProjectInformation')
    const payload = clone(this.state.projectByID)
    delete payload.project_type
    delete payload.created
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload._id
    delete payload.updated_by
    payload.licenses = this.state.licenses
    editProjectInformation(payload)
    this.setState({ showConfirmSave: !this.state.showConfirmSave })
    get(this.props, 'clickEditLicense')()
  }

  deleteLicense = (id) => {
    const licenses = clone(this.state.licenses)
    licenses.splice(id, 1)
    this.setState({ licenses })
  }

  clickAddLicense = () => {
    this.setState({
      showAddLicense: !this.state.showAddLicense,
      license_name: '',
      license_description: '',
      license_cost: 0,
      license_price: 0,
      license_sub_project_code: '',
      license_type: license_type[0].value,
    })
  }

  handleChangeCost = (e) => {
    const newLicenses = [...this.state.licenses]
    const license = this.state.licenses[e.target.id]
    const field = e.target.name
    if (field === 'cost' || field === 'price') {
      license[field] = parseFloat(e.target.value.replace(/,/g, ''))
    } else {
      license[field] = e.target.value
    }
    newLicenses[e.target.id] = license
    this.setState({ licenses: newLicenses })
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  /* eslint no-underscore-dangle: 0 */
  render() {
    const getProjectInformationByID = get(this.props, 'getProjectInformationByID')
    const clickEditLicense = get(this.props, 'clickEditLicense')
    return (
      <div style={ { marginLeft: 15, marginRight: 15 } }>
        <AddLicenseForm
          open={ this.state.showAddLicense }
          button={ addButton('addLicense', () => this.addLicense(), () => this.setState({ showAddLicense: !this.state.showAddLicense })) }
          handleInput={ this.handleInput }
          toggle={ () => this.setState({ showAddLicense: !this.state.showAddLicense }) }
          license_type={ this.state.license_type }
          license_cost={ this.state.license_cost }
          license_price={ this.state.license_price }
        />
        <ConfirmSaveForm
          open={ this.state.showConfirmSave }
          toggle={ () => this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          confirmSave={ this.confirmEditLicense }
        />
        <Searchbar
          editLicense={ this.state.editLicense }
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          clickEdit={ () => clickEditLicense() }
          clickAddLicense={ () => this.clickAddLicense() }
          confirmEditLicense={ () =>
            this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          cancelEdit={ () => {
            clickEditLicense()
            this.setState({ projectByID: null })
            getProjectInformationByID()
          } }
        />
        <LicensingTable
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          editLicense={ this.state.editLicense }
          search_license={ this.state.search_license }
          licenses={ this.state.licenses }
          deleteLicense={ this.deleteLicense }
          handleChangeCost={ this.handleChangeCost }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-licensing.js